import alertService from '../types/alert/alert.service';
import arrayService from '../types/array/array.service';
import checkboxService from '../types/checkbox/checkbox.service';
import collapseService from '../types/collapse/collapse.service';
import dateTimeService from '../types/date-time/date-time.service';
import dateService from '../types/date/date.service';
import fieldsetService from '../types/fieldset/fieldset.service';
import hiddenService from '../types/hidden/hidden.service';
import inputSelectConcatService from '../types/input-select-concat/input-select-concat.service';
import labelService from '../types/label/label.service';
import listService from '../types/list/list.service';
import nestedService from '../types/nested/nested.service';
import numberService from '../types/number/number.service';
import objectService from '../types/object/object.service';
import passwordService from '../types/password/password.service';
import percentService from '../types/percent/percent.service';
import radioService from '../types/radio/radio.service';
import scriptService from '../types/script/script.service';
import sectionService from '../types/section/section.service';
import selectIconService from '../types/select-icon/select-icon.service';
import selectMultipleService from '../types/select-multiple/select-multiple.service';
import selectService from '../types/select/select.service';
import stringService from '../types/string/string.service';
import tabsService from '../types/tabs/tabs.service';
import textService from '../types/text/text.service';
import textareaService from '../types/textarea/textarea.service';
import timeService from '../types/time/time.service';
import treeService from '../types/tree/tree.service';

export const TYPES = {
  alert: alertService,
  // @odeniel - INI - feature/162398-ec-form-builder-edicom-migrar-a-grid-nuevo
  // [HECHO] primera etapa de la migración:
  // - solo cambio en el selector de tipo
  // - borrar proyecto ec-grid-edicom
  // - borrar old_grid y servicio arrayService ... del ec-form-formBuilder
  // [PENDIENTE] segunda etapa de la migración
  // - renombre el ec-grid2 en ec-grid en form-edicom-components => revisar dependencias y frontend ...

  array: arrayService,
  // @odeniel - FIN
  checkbox: checkboxService,
  collapse: collapseService,
  dateTime: dateTimeService,
  date: dateService,
  time: timeService,
  fieldset: fieldsetService,
  hidden: hiddenService,
  inputSelectConcat: inputSelectConcatService,
  label: labelService,
  list: listService,
  nested: nestedService,
  number: numberService,
  object: objectService,
  password: passwordService,
  percent: percentService,
  radio: radioService,
  script: scriptService,
  section: sectionService,
  selectIcon: selectIconService,
  selectMultiple: selectMultipleService,
  select: selectService,
  string: stringService,
  tabs: tabsService,
  text: textService,
  textarea: textareaService,
  tree: treeService,
};
